import Property from '../utils/Property';

export default {
  create(data, id, session) {
    return new Property(data);
  }
};
